import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retried && !orig.url?.includes("/auth/")) {
      orig._retried = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch {
        // fall through
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
